<template>
    <div class="swiper-latest-news-wrapper">
        <div class="swiper-related-formation">
            <div class="swiper-wrapper">
                <div
                    v-for="(slide, index) in relatedFormations"
                    :key="'swiper-partners-slide-' + index"
                    class="swiper-slide"
                >
                    <router-link
                        :to="{ name: 'Formation-fr', params: { slug: slide.slug } }"
                        class="card-info-details"
                    >
                        <div class="card-header">
                            <FormationStatusLabel :item="slide" />
                            <h6 class="mb-0">{{ slide.title }}</h6>
                        </div>

                        <div class="card-body">
                            <div v-if="slide.lms !== true" class="subject-wrapper">
                                <p class="title-subject">
                                    {{ $t('Début de la formation') }}
                                </p>
                                <p v-if="slide.dateDeterminer && slide.dateDeterminer === true" class="subject">
                                    <span class="d-block">{{$t('Date à déterminer')}}</span>
                                    <span class="d-block">{{$t('Inscrivez-vous à la liste de rappel')}}</span>
                                </p>
                                <p v-else-if="slide.startDate && dateNotPassed(slide.startDate)" class="subject">
                                    <span class="d-block">{{$t('À venir')}}</span>
                                    <span class="d-block">{{$t('Inscrivez-vous à la liste de rappel')}}</span>
                                </p>
                                <p v-else-if="slide.startDate == 'null'" class="subject">
                                    {{$t('À venir')}}
                                </p>

                                <p v-else class="subject">{{$t('Le') + ' ' + theCoursDate(slide.startDate) }}</p>
                            </div>
                            <div class="subject-wrapper">
                                <p class="title-subject">{{ $t('Format') }}</p>
                                <p class="subject">{{ slide.format }}</p>
                            </div>
                            <div class="subject-wrapper">
                                <p class="title-subject">{{ $t('Durée') }}</p>
                                <p v-if="slide.lengthMonth !== 'null'" class="subject">
                                    {{ slide.lengthMonth }}
                                </p>
                                <p
                                    v-else
                                    class="subject"
                                    v-html="slide.lengthHour + ' ' + $t('heures')"
                                ></p>
                            </div>
                        </div>

                        <div class="card-footer">
                            <span class="stretched-link">
                                <span class="card-arrow link-arrow right no-margin"></span>
                            </span>
                        </div>
                    </router-link>
                </div>
            </div>
            <div class="swiper-pagination"></div>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import dayjs from 'dayjs'
// import AssetLoader from '@/components/helpers/AssetLoader'
import FormationStatusLabel from '@/components/Parts/FormationStatusLabel'
// import Swiper bundle with all modules installed
import Swiper from 'swiper/swiper-bundle.js'

// import NewsCard from '@/components/loopTemplate/NewsCard'

// import styles bundle
import 'swiper/swiper-bundle.min.css'

export default {
    name: 'SwiperRelatedFormations',
    components: {
        // NewsCard,
        FormationStatusLabel
    },
    props: {
        relatedFormations: {
            type: Array,
            required: true,
        },
    },
    watch: {
        pageIsLoaded: {
            async handler(pageIsLoaded) {
                if (pageIsLoaded) {
                    // Page loaded with Data
                    setTimeout(function () {
                        new Swiper('.swiper-related-formation', {
                            // Optional parameters
                            loop: false,
                            grabCursor: true,
                            slidesPerView: 'auto',
                            centeredSlides: false,
                            spaceBetween: 20,
                            // If we need pagination
                            pagination: {
                                el: '.swiper-pagination',
                                clickable: true,
                            },
                        })
                    }, 2000)
                }
            },
            immediate: true,
        },
    },
    computed: {
        pageIsLoaded() {
            return this.contentIsLoaded && this.globalsIsLoaded
        },
        ...mapState(['contentIsLoaded', 'globalsIsLoaded']),
        ...mapGetters(['content']),
    },
    methods: {
        theCoursDate(actualDate) {
            var date = dayjs(actualDate, "YYYY-MM-DD")
            return dayjs(date).format('D MMMM YYYY')
        },
        dateNotPassed(actualDate) {
            var date = new Date(actualDate)
            return dayjs().isAfter(dayjs(date));
        },
    },
}
</script>
